import { Component } from '@angular/core';
import { ToastService } from '@g99-product-web-ui/shared-service';
import { SharedUiModule } from '@g99-product-web-ui/shared-ui';
import { G99UiLibraryModule } from 'g99-ui-library';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'g99-prevew-ui',
  imports: [G99UiLibraryModule, SharedUiModule, ToastModule],
  templateUrl: './preview-ui.component.html',
  styles: [],
  standalone: true,
})
export class PreviewUIComponent {
  constructor(private readonly _toastService: ToastService) {}

  public onApiCallSuccess() {
    this._toastService.showSuccess('Data loaded successfully!', {
      closable: false,
      life: 5000,
    });
  }

  public onApiCallError() {
    this._toastService.showError('Failed to load data.', {
      closable: true,
      life: 10000,
    });
  }
}
